import * as React from "react";
import {ADVANTAGES_PATH, CAROUSEL_BANNERS, resourcesHelper} from "@falcon/services";
import {Link} from "react-router-dom";
import {pushClickEvent} from "./carouselEvents";

export class AllianzAdvantagesCarouselBanner extends React.Component {

    public render() {
        return (
            <div className="banner carousel-banner banner-content">
                <img className="banner-icon" src={`/${resourcesHelper.THEME}/img/gift_icon.svg`} alt="Gift icon"/>
                <div className="banner-text">
                    <div className="banner-title mb-3">{resourcesHelper.THEME} Advantages</div>
                    Don't forget to check out your latest offers and rewards in your new {resourcesHelper.THEME} Advantages area.
                    <p className="mt-3">
                        <Link
                            className="text-decoration-underline cursor-pointer text-blue-1 muli-bold-16"
                            onClick={this.onClick}
                            to={{pathname: ADVANTAGES_PATH}}>
                            <img className="carousel-banner-arrow"
                                 src={`/${resourcesHelper.THEME}/img/arrow-right.svg`}
                                 alt="Arrow icon"
                            />View my {resourcesHelper.THEME} Advantages
                        </Link>
                    </p>
                </div>
            </div>
        )
    }

    private onClick() {
        pushClickEvent(
            CAROUSEL_BANNERS.allianzAdvantages.name,
            ADVANTAGES_PATH,
            CAROUSEL_BANNERS.allianzAdvantages.id
        );
    }
}
